import { render, staticRenderFns } from "./ExpiredPage.vue?vue&type=template&id=307a85f0"
import script from "./ExpiredPage.vue?vue&type=script&lang=js"
export * from "./ExpiredPage.vue?vue&type=script&lang=js"
import style0 from "./ExpiredPage.vue?vue&type=style&index=0&id=307a85f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports